/* ProMechBC US Market routing + navigation + content guard. */
(function () {
  'use strict';
  var PREFIX = '/en-us';
  var STORE_HOSTS = ['promechbc.com', 'www.promechbc.com'];
  var ROUTABLE = ['/collections', '/products', '/pages', '/blogs', '/search', '/cart', '/policies', '/account'];

  function shouldPrefix(pathname) {
    if (!pathname || pathname === PREFIX || pathname.indexOf(PREFIX + '/') === 0) return false;
    if (pathname === '/') return true;
    return ROUTABLE.some(function (prefix) {
      return pathname === prefix || pathname.indexOf(prefix + '/') === 0;
    });
  }

  function usUrl(raw) {
    if (!raw || raw.charAt(0) === '#' || /^(mailto:|tel:|javascript:)/i.test(raw)) return raw;
    var url;
    try { url = new URL(raw, window.location.origin); } catch (e) { return raw; }
    if (STORE_HOSTS.indexOf(url.hostname.toLowerCase()) === -1) return raw;
    if (!shouldPrefix(url.pathname)) return raw;
    url.protocol = window.location.protocol;
    url.host = window.location.host;
    url.pathname = url.pathname === '/' ? PREFIX + '/' : PREFIX + url.pathname;
    return url.pathname + url.search + url.hash;
  }

  function routeAnchor(anchor) {
    if (!anchor || !anchor.getAttribute) return;
    var raw = anchor.getAttribute('href');
    var next = usUrl(raw);
    if (next && next !== raw) anchor.setAttribute('href', next);
  }

  function routeAll(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.matches && root.matches('a[href]')) routeAnchor(root);
    root.querySelectorAll('a[href]').forEach(routeAnchor);
  }

  function moveUsHomeIntoMain() {
    var home = document.querySelector('.pmb-us-home-section');
    var main = document.getElementById('MainContent');
    if (home && home.querySelector('.pmb-us-home') && main && home.parentElement !== main) {
      main.insertBefore(home, main.firstChild);
    }
  }

  function replaceUsPage() {
    var replacement = document.getElementById('PMB-US-PageReplacement');
    var main = document.getElementById('MainContent');
    if (!replacement || !main) return;
    var content = replacement.querySelector('.pmb-us-page');
    main.replaceChildren(replacement);
    replacement.hidden = false;
    routeAll(replacement);
    if (content) {
      var title = content.getAttribute('data-us-page-title');
      var description = content.getAttribute('data-us-page-description');
      if (title) document.title = title.indexOf('ProMechBC') > -1 ? title : title + ' | ProMechBC';
      var meta = document.querySelector('meta[name="description"]');
      if (meta && description) meta.setAttribute('content', description);
    }
    document.body.classList.add('pmb-us-page-replaced');
    document.documentElement.classList.remove('pmb-us-page-replacement-pending');
    main.style.visibility = '';
  }

  function replaceDesktopNav() {
    var nav = document.querySelector('.main-nav');
    if (!nav) return;
    nav.innerHTML = [
      ['Electric Scooters', PREFIX + '/collections/e-scooters'],
      ['Electric Bikes', PREFIX + '/collections/e-bikes'],
      ['Blog', PREFIX + '/blogs/blog'],
      ['About Us', PREFIX + '/pages/about-us'],
      ['Contact Us', PREFIX + '/pages/contact-us']
    ].map(function (item) {
      return '<a class="nav-link" href="' + item[1] + '">' + item[0] + '</a>';
    }).join('');
  }

  function replaceMobileNav() {
    var rootPanel = document.querySelector('[data-mobile-nav] [data-nav-panel="root"]');
    if (!rootPanel) return;
    var list = rootPanel.querySelector('.mnav__list');
    if (list) {
      list.innerHTML = [
        ['Electric Scooters', PREFIX + '/collections/e-scooters'],
        ['Electric Bikes', PREFIX + '/collections/e-bikes'],
        ['Blog', PREFIX + '/blogs/blog'],
        ['About Us', PREFIX + '/pages/about-us'],
        ['Contact Us', PREFIX + '/pages/contact-us']
      ].map(function (item, index) {
        return '<a class="mnav__row" href="' + item[1] + '" style="--i:' + index + '"><span class="mnav__row-txt">' + item[0] + '</span></a>';
      }).join('');
    }
    if (rootPanel.parentElement) {
      rootPanel.parentElement.querySelectorAll('[data-nav-panel]:not([data-nav-panel="root"])').forEach(function (panel) { panel.remove(); });
    }
  }

  function init() {
    document.body.classList.add('pmb-market-us');
    moveUsHomeIntoMain();
    replaceUsPage();
    replaceDesktopNav();
    replaceMobileNav();
    routeAll(document);
    document.documentElement.classList.add('pmb-us-ready');

    document.addEventListener('click', function (event) {
      var anchor = event.target.closest && event.target.closest('a[href]');
      if (anchor) routeAnchor(anchor);
    }, true);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) routeAll(node);
        });
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
